











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewMeetingTeamPicker_selectedTeam",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewMeetingTeamPickerAvatars_team"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node ).hash = "0245aba3236774ad16d4f38425de2116";

export default node;
